import type { FaireProductEntity } from "../../entity_types/product";

export const p_ve6ztrsfx8: FaireProductEntity = {
  token: "p_ve6ztrsfx8",
  type: "product",
  name: "Squish Cheese",
  brandToken: "b_418acca9",
  brandName: "Streamline",
  imageUrl:
    "https://cdn.faire.com/fastly/cfa730e644e97cf6c952aab3a2a545e9208440874aa74528568d003a4ee8442d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/edad3a61b526fa4974605e0e3dab106adde2c8bc8008284906748c77e86575f7.jpeg",
    "https://cdn.faire.com/fastly/a95bff5ce5e3cc425674f0686b4a2bcfefe5c45905ae6724fdad96d84fd446bb.jpeg",
  ],
  priceDollars: 5,
  description:
    "Get cheesy with Squish Cheese. Soft, stretchy, and totally irresistible, it’s made for nonstop squishing. Grab yours and enjoy the simple, gooey fun anytime!",
  tags: [],
  msrpDollars: 10,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:49.056Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
